(function(){'use strict';
var THRESHOLD=2000;
var prevCartTotal=0;

// ===== BARRE TIROIR PANIER (livraison uniquement) =====
function buildDrawerBars(cart){
  var block=document.createElement('div');
  block.className='mp-drawer-bars';
  var total=cart.total_price;
  var shRow=document.createElement('div');
  shRow.className='mp-drawer-bar-row';
  if(total>=THRESHOLD){
    shRow.innerHTML='<p class="mp-drawer-bar-text mp-drawer-bar-text--ok">✅ <strong>Livraison gratuite<\/strong> débloquée !<\/p>';
  }else{
    var shRem=((THRESHOLD-total)/100).toFixed(2).replace('.',',');
    var shPct=Math.min(100,Math.round((total/THRESHOLD)*100));
    shRow.innerHTML='<p class="mp-drawer-bar-text">🚚 Plus que <strong>'+shRem+'€<\/strong> pour la livraison gratuite<\/p><div class="mp-drawer-bar-track"><div class="mp-drawer-bar-fill mp-drawer-bar-fill--sh" style="width:'+shPct+'%"><\/div><\/div>';
  }
  block.appendChild(shRow);
  return block;
}

function refreshAll(cart){
  document.querySelectorAll('.mp-drawer-bars,.mp-upsell-bar').forEach(function(el){el.remove();});
  var bars=buildDrawerBars(cart);
  var drawer=document.querySelector('cart-drawer');
  if(drawer){
    var hdr=drawer.querySelector('.drawer__header,[class*="cart-drawer__header"]');
    if(hdr){hdr.insertAdjacentElement('afterend',bars);}else{drawer.prepend(bars);}
  }else{
    var form=document.querySelector('form[action="/cart"]');
    if(form)form.insertAdjacentElement('beforebegin',bars);
  }
  prevCartTotal=cart.total_price;
}

function refreshBar(){
  fetch('/cart.js').then(function(r){return r.json();}).then(refreshAll).catch(function(){});
}
document.addEventListener('DOMContentLoaded',refreshBar);
document.addEventListener('cart:updated',refreshBar);
document.addEventListener('cart:change',refreshBar);
document.addEventListener('dispatch:cart-drawer:open',function(){setTimeout(refreshBar,80);});
document.addEventListener('cart:open',function(){setTimeout(refreshBar,80);});

function initCartDrawerObserver(){
  var drawer=document.querySelector('cart-drawer');
  if(!drawer)return;
  var prevOpen=false;
  new MutationObserver(function(){
    var isOpen=drawer.classList.contains('is-open')||drawer.classList.contains('active')||drawer.hasAttribute('open');
    if(isOpen&&!prevOpen){setTimeout(refreshBar,100);}
    prevOpen=isOpen;
  }).observe(drawer,{attributes:true,attributeFilter:['class','open']});
  var cartItems=drawer.querySelector('.cart-items,.drawer__cart-items');
  if(cartItems){
    new MutationObserver(function(){
      if(prevOpen){setTimeout(refreshBar,150);}
    }).observe(cartItems,{childList:true,subtree:true});
  }
}

// ===== ORDRE MOBILE : image → achat → description =====
function fixMobileTabOrder(){
  var tabs=document.querySelector('.mp-product-tabs');
  var mediaWrapper=document.querySelector('.product__media-wrapper');
  var infoContainer=document.querySelector('.product__info-container');
  if(!tabs||!mediaWrapper||!infoContainer)return;
  var isMobile=window.innerWidth<990;
  if(isMobile&&tabs.parentElement===mediaWrapper){
    infoContainer.insertAdjacentElement('afterend',tabs);
  }else if(!isMobile&&tabs.parentElement!==mediaWrapper){
    mediaWrapper.appendChild(tabs);
  }
}

// ===== PAGE PRODUIT =====
function initProductPage(){if(!document.querySelector('.product__title'))return;injectSocialProof();injectBenefits();injectReassurance();injectGuarantee();injectOfferBanner();initDescriptionAccordion();initDescFaq();fixMobileTabOrder();}

function injectSocialProof(){
  var title=document.querySelector('.product__title');
  if(!title||document.querySelector('.mp-prod-social'))return;
  var el=document.createElement('div');
  el.className='mp-prod-social';
  el.innerHTML='<span class="mp-prod-social__stars">★★★★★<\/span><span class="mp-prod-social__score">4.9\/5<\/span><span class="mp-prod-social__sep">·<\/span><span class="mp-prod-social__text">2 400+ lecteurs satisfaits<\/span><span class="mp-prod-social__sep">·<\/span><span class="mp-prod-social__badge">✓ ACHAT VÉRIFIÉ<\/span>';
  title.insertAdjacentElement('beforebegin',el);
}

function injectBenefits(){
  if(document.querySelector('.mp-benefits'))return;
  var form=document.querySelector('product-form')||document.querySelector('.product-form');
  if(!form)return;
  var el=document.createElement('div');
  el.className='mp-benefits';
  el.innerHTML='<div class="mp-benefits__item"><span class="mp-benefits__emoji">🌿<\/span><span class="mp-benefits__label">Design Exclusif<\/span><\/div><div class="mp-benefits__item"><span class="mp-benefits__emoji">⭐<\/span><span class="mp-benefits__label">Finition Premium<\/span><\/div><div class="mp-benefits__item"><span class="mp-benefits__emoji">🎁<\/span><span class="mp-benefits__label">Idéal à Offrir<\/span><\/div>';
  form.insertAdjacentElement('beforebegin',el);
}

function injectReassurance(){
  if(document.querySelector('.mp-reassure'))return;
  var form=document.querySelector('product-form')||document.querySelector('.product-form');
  if(!form)return;
  var el=document.createElement('div');
  el.className='mp-reassure';
  el.innerHTML='<div class="mp-reassure__item"><div class="mp-reassure__icon">🚚<\/div><div class="mp-reassure__label">Livraison gratuite dès 20€<\/div><\/div><div class="mp-reassure__item"><div class="mp-reassure__icon">↩<\/div><div class="mp-reassure__label">Retours 14 jours<\/div><\/div><div class="mp-reassure__item"><div class="mp-reassure__icon">🎁<\/div><div class="mp-reassure__label">Emballage cadeau soigné<\/div><\/div><div class="mp-reassure__item"><div class="mp-reassure__icon">🔒<\/div><div class="mp-reassure__label">Paiement sécurisé<\/div><\/div>';
  form.insertAdjacentElement('beforebegin',el);
}

function injectGuarantee(){
  if(document.querySelector('.mp-guarantee'))return;
  var form=document.querySelector('product-form')||document.querySelector('.product-form');
  if(!form)return;
  var el=document.createElement('div');
  el.className='mp-guarantee';
  el.innerHTML='<div class="mp-guarantee__icon">🛡️<\/div><div class="mp-guarantee__text"><strong>Satisfait ou remboursé — 14 jours<\/strong><br>Sans condition, retour simple et rapide.<\/div>';
  form.insertAdjacentElement('beforebegin',el);
}

function injectOfferBanner(){
  if(document.querySelector('.mp-offer-banner'))return;
  var form=document.querySelector('product-form')||document.querySelector('.product-form');
  if(!form)return;
  var el=document.createElement('div');
  el.className='mp-offer-banner';
  el.innerHTML='<div class="mp-offer-banner__item"><span class="mp-offer-banner__emoji">🛍️<\/span><div class="mp-offer-banner__text"><strong>2 achetés → 3ème à -40%<\/strong> <span>— remise automatique au panier<\/span><\/div><\/div>';
  form.insertAdjacentElement('afterend',el);
}

function initDescriptionAccordion(){
  var desc=document.querySelector('.product__description');
  if(!desc||!desc.innerHTML.trim()||document.querySelector('.mp-product-tabs'))return;
  var temp=document.createElement('div');temp.innerHTML=desc.innerHTML;
  var h2s=Array.from(temp.querySelectorAll('h2'));
  var sections=[];
  if(h2s.length){
    h2s.forEach(function(h2){
      var title=h2.textContent.trim();
      var div=document.createElement('div');
      var sib=h2.nextSibling;
      while(sib&&sib.nodeName!=='H2'){div.appendChild(sib.cloneNode(true));sib=sib.nextSibling;}
      sections.push({title:title,html:div.innerHTML});
    });
  }else{
    sections.push({title:'Description du produit',html:temp.innerHTML});
  }
  desc.style.display='none';
  var wrap=document.createElement('div');wrap.className='mp-product-tabs';
  var nav=document.createElement('div');nav.className='mp-product-tabs__nav';
  var content=document.createElement('div');content.className='mp-product-tabs__content';
  sections.forEach(function(s,i){
    var btn=document.createElement('button');
    btn.className='mp-product-tabs__btn'+(i===0?' active':'');
    btn.textContent=s.title;btn.dataset.tab=''+i;
    nav.appendChild(btn);
    var panel=document.createElement('div');
    panel.className='mp-product-tabs__panel'+(i===0?' active':'');
    panel.id='mp-tab-'+i;panel.innerHTML=s.html;
    content.appendChild(panel);
  });
  nav.addEventListener('click',function(e){
    var btn=e.target.closest('.mp-product-tabs__btn');
    if(!btn)return;
    var idx=parseInt(btn.dataset.tab);
    nav.querySelectorAll('.mp-product-tabs__btn').forEach(function(b){b.classList.remove('active');});
    content.querySelectorAll('.mp-product-tabs__panel').forEach(function(p){p.classList.remove('active');});
    btn.classList.add('active');
    var panel=content.querySelector('#mp-tab-'+idx);
    if(panel)panel.classList.add('active');
    setTimeout(initDescFaq,50);
  });
  wrap.appendChild(nav);wrap.appendChild(content);
  var mediaWrapper=document.querySelector('.product__media-wrapper');
  if(mediaWrapper){mediaWrapper.appendChild(wrap);}
  else{
    var productEl=document.querySelector('.product');
    if(productEl){productEl.insertAdjacentElement('afterend',wrap);}
    else{var form=document.querySelector('product-form,.product-form');if(form)form.insertAdjacentElement('afterend',wrap);}
  }
}

function initDescFaq(){
  var items=document.querySelectorAll('.mp-desc-faq__item');
  if(!items.length)return;
  items.forEach(function(item){
    if(item.dataset.faqInit)return;
    item.dataset.faqInit='1';
    var q=item.querySelector('.mp-desc-faq__q');
    if(!q)return;
    q.addEventListener('click',function(){
      var isOpen=item.classList.contains('open');
      items.forEach(function(other){other.classList.remove('open');});
      if(!isOpen)item.classList.add('open');
    });
  });
}

document.addEventListener('DOMContentLoaded',function(){
  initProductPage();
  initCartDrawerObserver();
  var resizeTimer;
  window.addEventListener('resize',function(){
    clearTimeout(resizeTimer);
    resizeTimer=setTimeout(fixMobileTabOrder,200);
  });
});
})();
